import { Effect, Record as EffectRecord, Schema } from 'effect';

export const UserFeatureFlagSchema = Schema.Literals([
  'googleDrive',
  'dropbox',
]);
export type UserFeatureFlag = typeof UserFeatureFlagSchema.Type;

export const UserFeatureFlags = Schema.Struct({
  googleDrive: Schema.Boolean.pipe(
    Schema.withDecodingDefaultType(Effect.succeed(false)),
  ),
  dropbox: Schema.Boolean.pipe(
    Schema.withDecodingDefaultType(Effect.succeed(false)),
  ),
  cloudImports: Schema.Boolean,
});
export type UserFeatureFlags = typeof UserFeatureFlags.Type;

type FlagDefinition = {
  readonly label: string;
  readonly description: string;
};

export const USER_FEATURE_FLAGS = {
  googleDrive: {
    label: 'Google Drive',
    description:
      'Connect and import from Google Drive. In production only accounts set to Allow have it; elsewhere it is on unless blocked.',
  },
  dropbox: {
    label: 'Dropbox',
    description:
      'Connect and import from Dropbox. In production only accounts set to Allow have it; elsewhere it is on unless blocked.',
  },
} as const satisfies Record<UserFeatureFlag, FlagDefinition>;

export const userFeatureFlagOverrides = (
  rows: ReadonlyArray<{ readonly flag: string; readonly enabled: boolean }>,
) =>
  new Map(
    rows.flatMap((row) =>
      Schema.is(UserFeatureFlagSchema)(row.flag)
        ? [[row.flag, row.enabled] as const]
        : [],
    ),
  );

export const resolveUserFeatureFlags = (
  production: boolean,
  overrides: ReadonlyMap<UserFeatureFlag, boolean>,
) => {
  const flags = EffectRecord.map(
    USER_FEATURE_FLAGS,
    (_, flag) => overrides.get(flag) ?? !production,
  );
  return { ...flags, cloudImports: flags.googleDrive && flags.dropbox };
};
